import React from "react";
import './style.css'; 

import footerlogoImg1 from "../../assets/tvec-logo.png";
import footerlogoImg2 from "../../assets/ccoo-logo.png";
import footerlogoImg3 from "../../assets/wco-logo.png";
import footerlogoImg4 from "../../assets/apcoo-logo.png";
import footerlogoImg5 from "../../assets/tvec-qms.png";

export const FooterComp = () => {
  return (
    <footer className="footer-background text-light py-4">
      <div className="container">
        <div className="row">
          {/* Left Section with Logo and About */}
          <div className="col-md-4 mb-4 mb-md-0">
            <div className="d-flex align-items-center">
              <img
                src="logo.jpg" // Add logo path here
                alt="Eye Care Institute Logo"
                className="img-fluid rounded-circle mb-3"
                width="80"
                height="80"
              />
              <div className="ms-3">
                <h5 className="text-uppercase font-weight-bold">About Eye Care Institute</h5>
                <p className="text">
                 We are a leading non-state higher education institute, approved by the Ministry of Education and accredited 
                 by the Tertiary & Vocational Education Commission (TVEC). Additionally, we are members of the World Council of Optometry (WCO) 
                 and the Asia Pacific Council of Optometry (APCO). Our Optician and Optometry courses are recognized 
                 by the Ceylon Council of Optometrists & Orthoptists (CCOO), Sri Lanka. ECI is the first Sri Lankan private 
                 institute to be recognized by the Government of Sri Lanka. We are the only Optometry institute affiliated with an university.                </p>
              </div>
            </div>
          </div>

          {/* Middle Section with Quick Links */}
          <div className="col-md-4 mb-4 mb-md-0">
            <h5 className="text-uppercase font-weight-bold">Quick Links</h5>
            <ul className="list-unstyled">
              <li><a href="/" className="text text-decoration-none">Home</a></li>
              <li><a href="/whoweare" className="text text-decoration-none">About Us</a></li>
              <li><a href="/courseregistration" className="text text-decoration-none">Course Registration</a></li>
              <li><a href="/ourfaculty" className="text text-decoration-none">Our Faculty</a></li>
              <li><a href="/gallery" className="text text-decoration-none">Gallery</a></li>
              <li><a href="/newsandevents" className="text text-decoration-none">News & Events</a></li>
              <li><a href="/contactus" className="text text-decoration-none">Contact Us</a></li>
              <li><a href="https://optometryassociation.lk" className="text text-decoration-none" target="_blank" rel="noopener noreferrer">Ceylon Eye Care Optometry Association</a></li>
            </ul>
          </div>

          <div className="col-md-4">
            <h5 className="text-uppercase font-weight-bold">Contact Us</h5>
            <div className="mb-3">
              <p className="mb-1 text">Email: <a href="mailto:info@eyecareinstitute.lk" className="text text-decoration-none">info@eyecareinstitute.lk</a></p>
              <p className="mb-1 text">Call Us: <a href="tel:+94112682277" className="text text-decoration-none">+94 112 682 277</a></p>
              <p className="mb-1 text"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;    : <a href="tel:+94761010747" className="text text-decoration-none">+94 76 101 0747</a></p>
              <p className="mb-1 text"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;    : <a href="tel:+94773440937" className="text text-decoration-none">+94 77 344 0937</a></p>

            </div>

            <h5 className="text-uppercase font-weight-bold">Follow Us</h5>
            <div className="d-flex mb-3">
         
              <a 
                href="https://web.facebook.com/EYECARESRILANKA" 
                className="text me-3" 
                aria-label="Facebook" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <i className="fab fa-facebook fa-2x"></i>
              </a>

              <a 
                href="https://www.instagram.com/instituteyecare" 
                className="text me-3" 
                aria-label="Instagram" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram fa-2x"></i>
              </a>


                <a href="https://www.linkedin.com/company/eye-care-institute-%E2%80%93-vision-health-education/about/?viewAsMember=true" 
                  className="text me-3" 
                  aria-label="LinkedIn"
                  target="_blank" 
                  rel="noopener noreferrer">
                  <i className="fab fa-linkedin fa-2x"></i>
                </a>

                
                <a href="https://www.youtube.com/@eyecareinstitutesrilanka8780" 
                  className="text me-3" 
                  aria-label="YouTube"
                  target="_blank" 
                  rel="noopener noreferrer">
                  <i className="fab fa-youtube fa-2x"></i>
                </a>

                <a href="mailto:info@eyecareinstitute.com" className="text me-3" aria-label="Email">
                  <i className="fas fa-envelope fa-2x"></i>
                </a>
            </div>

            <h5 className="text-uppercase font-weight-bold">Accredited & Member</h5>
            <div className="d-flex mb-3">
         
              <a 
                href="https://www.tvec.gov.lk/" 
                className="text me-3" 
                aria-label="TVEC" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                 <img src={footerlogoImg1} alt="logo" height="50" width="80" />
              </a>

                <a href="https://www.ccoo.lk/" 
                  className="text me-3" 
                  aria-label="ccoo"
                  target="_blank" 
                  rel="noopener noreferrer">
                  <img src={footerlogoImg2} alt="logo" height="50" width="80"  />
                </a>

                <a href="https://worldcouncilofoptometry.info/" 
                  className="text me-3" 
                  aria-label="wcoo"
                  target="_blank" 
                  rel="noopener noreferrer">
                  <img src={footerlogoImg3} alt="logo" height="50" width="80"  />
                </a>

                <a href="https://www.asiapacificoptometry.org/" 
                  className="text me-3" 
                  aria-label="apcoo"
                  target="_blank" 
                  rel="noopener noreferrer">
                  <img src={footerlogoImg4} alt="logo" height="50" width="80"  />
                </a>

                <a>
                   <img src={footerlogoImg5} alt="logo" height="50" width="80"  />
                </a>
            </div>

          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="text-center mt-4">
          <p className="mb-0">&copy; 2025 Eye Care Institute. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
